


















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import ItemIdChip from './ItemIdChip.vue'

@Component({
  components: { ItemIdChip },
})
export default class ActionsCard extends Vue {
  @Prop({ default: false })
  public isIdShown!: boolean
  @Prop({ default: true })
  public hasCancelOKButton!: boolean
  @Prop({ required: false })
  public idString!: string
  @Prop({ default: false })
  public isErrorShown!: boolean
  @Prop({ required: false })
  public errorMessage!: string
  @Prop({ default: true })
  public isEnabled!: boolean

  public cancelled(item) {
    this.$emit('cancelled')
  }
  public committed(item) {
    this.$emit('committed')
  }
}
